import { render, staticRenderFns } from "./LsProductCard.vue?vue&type=template&id=1522b55f&scoped=true&"
import script from "./LsProductCard.vue?vue&type=script&lang=js&"
export * from "./LsProductCard.vue?vue&type=script&lang=js&"
import style0 from "./LsProductCard.vue?vue&type=style&index=0&id=1522b55f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522b55f",
  null
  
)

export default component.exports